var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentLocation)?_c('span',[_vm._v(_vm._s(_vm.currentLocation && _vm.currentLocation.title))]):(_vm.currentLocation === null)?_c('span',{staticClass:"has-text-grey"},[_c('i',{directives:[{name:"t",rawName:"v-t",value:('location.location_not_available'),expression:"'location.location_not_available'"}]})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }